import sortByProp from "../../lib/sortByProp";
import pipelineBurstActionsMap from 'redux/lib/pipelineBurstActionsMap.js';

const generateActions = (actions = []) => {
  let finalActions = [];
  actions.forEach((action) => {
    let mutated = false;
    //when category is template, split out text and email into separate actions
    if (action.category === 'template') {
      const fields = Object.keys(action.fields || {});
      fields.forEach((field) => {
        let fieldSplit = field.split(':');
        if (['email', 'text'].includes(fieldSplit[0])) {
          finalActions.push({
            id: `${fieldSplit[0]}_${fieldSplit[1]}`,
            category: fieldSplit[0],
            fields: { [fieldSplit[1]]: action.fields[field] },
            ...pipelineBurstActionsMap[fieldSplit[0]],
          });
          mutated = true;
        }
      });
    }
    if (!mutated) {
      //this id, is used to create unique reference to determine the status of a given action
      let id = [action.category, ...Object.keys(action.fields)].join('_');
      finalActions.push({ id, ...action, ...pipelineBurstActionsMap[action.category] });
    }
  });
  return finalActions;
};

const getActionProperties = (propsStr) => {
  let props = JSON.parse(propsStr || null) || {};
  return {
    ...props,
    actions: generateActions(props.actions),
  };
};

// Deep map to compute action properties
const formatPipelines = (pipelines = []) => {
  return pipelines.sort(sortByProp('pipeline_name')).map((n) => ({ ...n, stages: (n.stages || []).map((m) => ({ ...m, actions: (m.actions || []).map((p) => ({ ...p, ...getActionProperties(p.action_properties) })) })) }));
};

export default formatPipelines;
